export const INPUT_MASK = "(999) 999-99-99";

export const PLACEHOLDER = "(___) ___-__-__";